import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from 'modules/actions/bidProjectDetail';
import * as moveActions from 'modules/actions/bidProjectMove';

import { Transition } from 'react-transition-group';
import './index.less';
import { searchToQuery } from 'utils/router';
// import { element } from '@beehive/utils';
import { Spin } from '@beehive/components';
import { Dispatch, bindActionCreators } from 'redux';
// import HeaderForm from './HeaderForm';
// import BaseInfo from './BaseInfo';
import { getNodeBaseInfoMapComp } from './utils';
import { ExtraContextProvider, OptionsContextProvider } from './components/DetailLayout/context';
import { isBlank } from 'utils/object';
import { useScreenAdapterContext } from '@bedrock/eed-react'
import useLayoutContentWidth from '@mpc/common/src/hooks/useLayoutContentWidth';

const TRANSITION_STYLE = {
  entering: { right: '-100%' },
  entered: { right: 0 },
  exiting: { right: 0 },
  exited: { right: '-100%' },
};

const ProjectDetailDrawer = (props: any) => {
  const {
    prefixCls = 'bidding-detail',
    location,
    clearDetail,
    history,
    projectDetail,
    loadDetail,
    leftSideWidth,
    projectMove,
    refreshList,
  } = props;
  // const [mode] = React.useState('show');
  const { viewBase } = useScreenAdapterContext();
  
  const layoutContentWidth = useLayoutContentWidth();

  const query = searchToQuery(location);
  const projectId = +String(query.projectId);
  const hasProjectId = !!projectId;

  const { detail = {}, quoteData } = projectDetail;

  const handleTransitionExited = () => {
    clearDetail();
  };

  const getDetail = (params: any = {}) => {
    // const menuKey = this.getMenuKey();
    const newParams = { ...params };
    projectId && loadDetail(projectId, newParams);
  };

  React.useEffect(() => {
    if (hasProjectId) {
      getDetail();
    }
  }, [projectId]);

  const widtStyle = `calc(100vw - ${leftSideWidth * viewBase}px)`;

  const mapComponent = getNodeBaseInfoMapComp({
    detail,
    quoteData,
    getDetail,
    projectMove,
    history,
    location,
    projectId,
    refreshList,
  });

  return (
    <Transition
      in={hasProjectId}
      mountOnEnter={true}
      appear={true}
      timeout={200}
      onExited={handleTransitionExited}
    >
      {(state) => {
        return (
          <div
            className={`${prefixCls}`}
            style={{ ...TRANSITION_STYLE[state], width: layoutContentWidth }}
          >
            <Spin.Global spinning={projectDetail.detailLoading} />
            {!isBlank(detail) && (
              <OptionsContextProvider productId={detail.product_id}>
              <ExtraContextProvider showBack={true}>
                {mapComponent}
              </ExtraContextProvider>
            </OptionsContextProvider>
            )}
          </div>
        );
      }}
    </Transition>
  );
};

const mapStateToProps = (state: any) => {
  const projectDetail = state.bidProjectDetail;
  return {
    projectDetail,
  };
};

export function mapDispatchToProps(dispatch: Dispatch<any>, ownProps: any) {
  return bindActionCreators(
    {
      loadDetail: actions.loadDetail,
      clearDetail: actions.clearDetail,
      projectMove: moveActions.projectMove,
      refreshList: moveActions.refreshList,
      projectDelete: moveActions.projectDelete,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectDetailDrawer);
